module.exports = __webpack_public_path__ + "5d4b221b9a13ada6a77a4beffdfc1f93.png";